import axios from 'axios';
import {PlanOpportunityViewModel} from './dataModels.js';
import {getAuthHeader} from  '../global_helpers/authHeader.js';



const state = {
    planOpportunityViewmodel: new PlanOpportunityViewModel(),

    planContext: {
        planOpportunity: null,
        plan_id: null,
        packets: {
            used_rks: [],
            available_rks: [],
            packets: [],
            proposal: {}
        },
    }
};

const getters = {
    getplanOpportunityViewmodel: (state) => state.planOpportunityViewmodel,
    planOpportunity: (state) => state.planContext.planOpportunity,
};

const actions = {
    
    async clearPlanOpportunityViewModelState({commit}){
        commit('clearPlanOpportunityViewModelState');
    },

    async clearPlanAction({commit}){
        commit('clearPlanState');
    },
    
    async sendEmail({dispatch}, obj){
        let authHeader = getAuthHeader();        
        axios.post('/planopportunity/email/', obj, authHeader).then(
            dispatch('raiseMessage','Your email has been successfully sent!', {root: true}),
            dispatch('clearUserObject', {root: true})
        )
        .catch(err => {
            console.log(err);
            dispatch('raiseMessage', 'Oh no! An error occurred when trying to send your email!', {root: true})
        })
    },
    
    async updatePlanAgreementExecution({commit, dispatch}, obj){
        let authHeader = getAuthHeader();
        
        let object = {
            agreement: {
                   agreement_id:        obj.agreement.agreement_id,
                   proposal_id:         obj.agreement.proposal_id,
                   client_id:           obj.agreement.client_id,
                   plan_opportunity_id: obj.agreement.plan_opportunity_id,
                   sponsor_first_name:  obj.agreement.sponsor_first_name,
                   sponsor_last_name:   obj.agreement.sponsor_last_name,
                   sponsor_email:       obj.agreement.sponsor_email,
                   sponsor_address:     obj.agreement.sponsor_address,
                   sponsor_city:        obj.agreement.sponsor_city,
                   sponsor_state:       obj.agreement.sponsor_state,
                   sponsor_zip:         obj.agreement.sponsor_zip,
                   sponsor_phone:       obj.agreement.sponsor_phone,
                   sponsor_fax:         obj.agreement.sponsor_fax,
                   sponsor_ein:         obj.agreement.sponsor_ein,
                   template_id:         obj.agreement.template_id,
                   date_time_reviewed:  obj.agreement.date_time_reviewed,
            }
            
        }
        let plan_op = {
            plan_opportunity: {
                plan_opportunity_id:    obj.agreement.plan_opportunity_id,
                plan_name:              obj.agreement.plan_name,
                plan_year_begin:        obj.agreement.plan_year_begin,
                plan_year_end:          obj.agreement.plan_year_end,
            }
        }
        
        axios.put('/planopportunity/', plan_op, authHeader)
        
        .then((res) => {
            commit('setPlan', res.data)
            dispatch('createAgreement', object, {root: true})
        })
        
        .catch(err => {
            console.log(err);
            dispatch('raiseMessage', 'An error occurred when generating your agreement!', {root: true})
        })
    },
    
    //region PlanOpportunity CRUD
    
    async createPlanopportunity({commit, dispatch}, client){
        console.log(`createPlanopportunity client: ${JSON.stringify(client)}`);
        let authHeader = getAuthHeader();
        axios.post('/planopportunity/', {'client':client}, authHeader)
        .then((res) => {
            commit('setPlanID', res.data.plan_opportunity.plan_opportunity_id);
            commit('setPlan', res.data);
            commit('setPlanVM', res.data);
        })
        .catch(err => {
            console.log(err);
            dispatch('raiseMessage', 'Error creating plan opportunity', {root: true});
        });
    },
    
    async getPlanOpportunity({commit, dispatch}, plan_id){
        let authHeader = getAuthHeader();
        console.log(`getPlanOpportunity plan_id: ${plan_id}`);
        axios.get('/planopportunity/?plan_opportunity_id='+plan_id, authHeader)
        .then((res) => {
            console.log(`getPlanOpportunity res: ${JSON.stringify(res.data)}`);
            commit('setPlan', res.data);
            commit('setPlanVM', res.data);
        })
        .catch((err) => {
            console.log(err);
            dispatch('raiseMessage', 'Error loading plan opportunity', {root: true});
        });
    },

    async getPlanOppViewmodel({commit,dispatch}, plan_id){
        let authHeader = getAuthHeader();
        console.log(`getPlanOppViewmodel plan_id: ${plan_id}`);
        axios.get('/planopportunity/viewmodel/?plan_opportunity_id='+plan_id, authHeader)
        .then((res) => {
            console.log(`getPlanOppViewmodel res: ${JSON.stringify(res.data)}`);
            commit('setPlanVM', res.data);
        })
        .catch((err) => {
            console.log(err);
            dispatch('raiseMessage', 'Error loading plan opportunity viewmodel', {root: true});
        });
    },
    
    async updatePlanOpportunity({commit, dispatch}, plan_op){
        let authHeader = getAuthHeader();
        axios.put('planopportunity/', plan_op, authHeader)
        .then((res) => {
            commit('setPlan', res.data);
            commit('setPlanVM', res.data);
        })
        .catch(err => {
            console.log(err);
            dispatch('raiseMessage', 'Error updating plan opportunity', {root: true});
        });
    },
    
    async closeCreatePlanopportunity({commit, dispatch}, params){
        let authHeader = getAuthHeader();
        commit('clearPlanState');
        console.log(`closeCreatePlanopportunity params: ${JSON.stringify(params)}`);
        axios.get('planopportunity/close_create/?client_id='+params.client_id+'&planopportunity_id='+params.plan_id, authHeader)
        .then((res) => {
            console.log(`closeCreatePlanopportunity res: ${JSON.stringify(res.data)}`);
            commit('setPlan', res.data);
            commit('setPlanVM', res.data);
        })
        .catch(err => {
            console.log(err);
            dispatch('raiseMessage', 'Error closing and creating plan opportunity', {root: true});
        });
    },

    //endregion
};

const mutations = {

    setPlanVM(state, vm){
        console.log('setPlanVM mutation');
        state.planOpportunityViewmodel = new PlanOpportunityViewModel(vm);
        console.log(state.planOpportunityViewmodel);
    },
    
    clearPlanOpportunityViewModelState(state){
        console.log('clearPlanOpportunityViewModelState')
        state.planOpportunityViewmodel = new PlanOpportunityViewModel();
        console.log(state.planOpportunityViewmodel.plan_opportunity)
    },

    //TODO clear all uses of the below mutations
    setPlan(state, plan){
        console.log('setPlan mutation');
        state.planContext.planOpportunity = plan
        state.planContext.plan_id = plan.plan_opportunity.plan_opportunity_id
    },
    
    clearPlanState(state){
        state.planContext.planOpportunity = null
        state.planContext.plan_id = null
    },
    
    setPlanID(state, plan_id){
        state.planContext.plan_id = plan_id
    },
    
    setPlanPackets(state, packets){
        state.planContext.packets = packets
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};